import { taskGroupsQuery } from "@common/api/quoting/task-group"
import type { QuoteTaskGroupPublic } from "@common/client"
import { useHasPermission } from "@common/hooks/use-permissions"
import { useQuery } from "@tanstack/react-query"

export function useTaskGroupsReadable(): boolean {
  return useHasPermission("quote_task_group:read")
}

export function useTaskGroups(): QuoteTaskGroupPublic[] {
  const readable = useTaskGroupsReadable()
  const { data } = useQuery({
    ...taskGroupsQuery({ deleted: false }),
    enabled: readable,
  })
  return data?.data ?? []
}
